import { useState } from 'react';
import { apiClienth5Login } from '../../api';
import main from '../../main';
import { showToast } from '../../utils/utils';

interface Props {
  onLogin: (v: string) => void;
}
export default function LoginPage({ onLogin }: Props) {
  const [phone, setphone] = useState<string>('');
  const [userInfo, setuserInfo] = useState<string>('');
  function verifyData() {
    let msg = '';
    let reg = /^1[3456789]\d{9}$/;
    if (!phone) {
      msg = '请输入手机号';
    } else if (!reg.test(phone)) {
      msg = '请输入正确的手机号';
    } else if (!userInfo) {
      msg = '请输入收货姓名/身份证号';
    }
    return msg;
  }
  async function handLogin() {
    if (!!verifyData()) {
      return showToast(verifyData());
    }
    try {
      let res = await apiClienth5Login({ phone, userInfo, code: main?.shopId });
      if (res.code === 200) {
        let data = res.data;
        localStorage.setItem('token', data);
        main.token = data;
        console.log('data', main.token);
        onLogin(data);
      } else {
        showToast(res.msg ?? '登录失败，请稍后再试');
      }
    } catch (error) {}
  }
  return (
    <div
      className="login-page bw-100"
      // style={{
      //   background: 'url("/pic/login_bg.png")',
      //   backgroundRepeat: 'no-repeat',
      //   backgroundSize: 'cover',
      // }}
    >
      <div className="bw-100 bh-90 pl-20 pr-20 d-flex-r ai-center jc-center font-size-14">
        <div className="login-centext bg-white p-20 border-radius-12">
          <div className="font-size-20 font-widget-600 mb-20 text-center">订单查询</div>
          <div className="d-flex-c">
            <div className="text-color-6 mb-5">订单收货手机号</div>
            <input
              className="login-search-input flex-1 pt-10 pb-10"
              value={phone}
              placeholder="请输入订单收货人手机号"
              onChange={(e) => setphone(e.target.value)}
            />
          </div>
          <div className="d-flex-c mt-30">
            <div className="text-color-6 mb-5">收货姓名/身份证号</div>
            <input
              className="login-search-input flex-1 pt-10 pb-10"
              value={userInfo}
              placeholder="请输入收货姓名/身份证号"
              onChange={(e) => setuserInfo(e.target.value)}
            />
          </div>
          <div className="mt-30 bg-p pt-15 pb-15 border-radius-20 text-color-white text-center" onClick={handLogin}>
            立即查询
          </div>
        </div>
      </div>
    </div>
  );
}
